//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ListEditInput',
  props: {
    item: { type: Object, default: () => {} },
  },
  data() {
    return {
      originName: '',
      originLink: '',
    };
  },
  computed: {
    isChange() {
      return (
        this.originLink !== this.item.link || this.originName !== this.item.name
      );
    },
  },
  mounted() {
    this.originName = this.item.name;
    this.originLink = this.item.link;
  },
};
